import config from '@/config/config.app.json'

// All OIDC URLs derive from portalApi (Config Service value, trailing slash trimmed).
// The SPA's app identifier is a code constant - not a tenant config key.
// Default to '' when the key is absent: this module loads on every tenant's boot path (main.js -> oidc-bootstrap,
// and via auth.js), so a missing portalApi must not throw at module-eval and white-screen non-OIDC tenants. OIDC
// tenants always configure it.
const PORTAL_API = (config.portalApi || '').replace(/\/$/, '')

/**
 * OIDC endpoints and identifiers used across the OIDC modules. Endpoint URLs are built from `config.portalApi`
 * so they follow the configured portal per environment.
 *
 * @typedef {Object} OidcConfig
 * @property {string} loginUrl         Portal endpoint that starts the OIDC login flow.
 * @property {string} exchangeUrl      Portal endpoint that exchanges an OTC for an API token.
 * @property {string} logoutUrl        Portal endpoint that ends the OIDC session (Portal -> IdP -> SPA).
 * @property {string} sessionCheckUrl  Portal endpoint that returns the current SSO session, used for the
 *                                     bootstrap probe and the tab-focus revalidation.
 * @property {string} callbackPath     Path the portal redirects to after login (matched against
 *                                     `window.location.pathname` and the hash route).
 * @property {string} appId            Stable identifier sent to the portal so it can return to the right SPA.
 *
 * @type {OidcConfig}
 */
export const OIDC = {
  loginUrl:        `${PORTAL_API}/auth-oidc/login`,
  exchangeUrl:     `${PORTAL_API}/auth-oidc/exchange`,
  logoutUrl:       `${PORTAL_API}/auth-oidc/logout`,
  sessionCheckUrl: `${PORTAL_API}/auth-oidc/session`,
  callbackPath:    '/oidc-callback',
  appId:           'bisaknosp',
}
